/**
 *エラー 画面のグロッサリIDの型定義
 *
 * IDの先頭5桁（GL00x）は同一ファイル内では同じものを使用し、グロッサリファイル間では一意とする。
 * それ以降の5桁はファイル内でIDが被らないように採番する。
 */
export const ErrorsGL = {
  /** プラン{0}は契約中です */
  AlreadyContracted: 'GL00510001',
  /** お探しのページは存在しません */
  NotFound: 'GL00510002',
  /** プラン一覧に戻る */
  ToPlanList: 'GL00510003',
  /** ログアウトして終了 */
  ToLogout: 'GL00510004',
  /** プランの管理(COMMON_0015) */
  ToContractList: 'GL00510005',
  /** 一部同じ機能が含まれている商品を購入しています。購入しますか？ */
  PartiallyDuplicated: 'GL00510006',
  /** 購入する */
  ToBuy: 'GL00510007',
  /** ご購入手続き中にエラーが発生しました */
  PurchaseError: 'GL00510009',
  /** 購入可能なプランがありません */
  NotFoundPurchasePlan: 'GL00510010',
  /** ご解約手続中にエラーが発生しました */
  CancelPurchaseError: 'GL00510011',
  /** 同じ機能を含むプランを既にご利用中です。購入手続きを行いますか？ */
  PurchaseAdditional: 'GL00510012',
  /** 現在の合計消費数 : {0} / {1} */
  PurchaseAdditionalStatus: 'GL00510013',
  /** プランが購入者へ返却できませんでした。時間をおいて再度お試しください。 */
  CancelConfirmationError: 'GL00510014',
  /** 同じ機能を含むプランを既にご利用中です。購入手続きを行いますか？ */
  DuplicatePurchase: 'GL00510012',
  /** ご購入可能な数量が上限に達しました。購入数をご確認ください。 */
  DuplicatePurchased: 'GL00510015'
} as const;
export type ErrorsGLKeys = typeof ErrorsGL[keyof typeof ErrorsGL];
